@if (errorMessage$ | async; as errorMessage) {
    <bs-alert [type]="alertType" [message]="errorMessage" />
}
